import { createAsyncThunk, AsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { showSuccessMessage, showErrorMessage } from '../notifications';
import { SERVICES, HttpMethods } from '../../services/api';
import { actions as TeamListActions } from './list';
import { BillingCadenceTypes, ITeam } from './team';
import { IAccountDetails } from '../users/user';

export interface ICreateTeamDTO {
  id?: string;
  name: string;
  accountId?: string;
  isActive: boolean;
  lastCampaignLaunchAt?: Date;
  activeUsers?: number;
  account?: IAccountDetails;
  members?: string[];
  billingContact?: string;
  billingCadence?: BillingCadenceTypes;
}

export const createTeam: AsyncThunk<void, ICreateTeamDTO, ThunkAPI> = createAsyncThunk(
  'teams/createTeam',
  async (teamData: ICreateTeamDTO, thunk) => {
    try {
      const response = await basicApiAsyncThunkCreator<void, ICreateTeamDTO>({
        endpoint: 'teams',
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(teamData, thunk);
      thunk.dispatch(TeamListActions.fetchTeamsList({}));
      thunk.dispatch(showSuccessMessage('Team created successfully'));
      return response;
    } catch(err) {
      thunk.dispatch(showErrorMessage(typeof err === 'string' ? err : 'An error occurred creating the new team'));
      return thunk.rejectWithValue(err);
    }
  }
);

export const editTeam: AsyncThunk<string, ICreateTeamDTO, ThunkAPI> = createAsyncThunk(
  'teams/editTeam',
  async (teamData: ICreateTeamDTO, thunk) => {
    try {
      thunk.dispatch(TeamListActions.setEditingTeam(teamData.id || ''));
      await basicApiAsyncThunkCreator<void, ICreateTeamDTO>({
        endpoint: 'teams',
        method: HttpMethods.Patch,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        contentType: 'application/json'
      })(teamData, thunk);
      thunk.dispatch(TeamListActions.updateTeam(teamData as ITeam));
      thunk.dispatch(TeamListActions.clearEditingTeam());
      thunk.dispatch(showSuccessMessage('Team updated successfully'));
      return teamData.id || '';
    } catch(err) {
      thunk.dispatch(showErrorMessage(typeof err === 'string' ? err : 'An error occurred updating the team'));
      thunk.dispatch(TeamListActions.clearEditingTeam());
      return thunk.rejectWithValue(err);
    }
  }
);
